import { topupAmounts } from "@/framework/billing/topup/topupAmounts";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

type CreditAmountButtonsProps = {
  amounts?: readonly number[];
  selectedAmount: number | null;
  onSelectAmount: (amount: number) => void;
};

export const CreditAmountButtons = ({
  amounts = topupAmounts,
  selectedAmount,
  onSelectAmount,
}: CreditAmountButtonsProps) => (
  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
    {amounts.map((amount) => (
      <Button
        key={amount}
        variant={selectedAmount === amount ? "contained" : "outlined"}
        onClick={() => onSelectAmount(amount)}
      >
        {amount}
      </Button>
    ))}
  </Box>
);
